import { APP_INITIALIZER, DEFAULT_CURRENCY_CODE, LOCALE_ID, NgModule } from '@angular/core';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { prefersReducedMotion } from './shared/utils/reduced-motion';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from "@angular/material/form-field";
import { MatPaginatorIntl } from '@angular/material/paginator';
import { CustomPaginatorIntl } from './shared/services/custom-paginator-intl';
import { MENU_ITEMS, SIDENAV_CONFIG } from "./layout/models/data-sidenav";
import { StoreModule as StoreCustomModule } from './store/store.module';
import { MaterialModule } from './material/material/material.module';
import { DateAdapter, MatNativeDateModule } from '@angular/material/core';
import { FixedFormatDateAdapter } from './shared/services/fixed-format-date-adapter';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { environment } from 'src/environments/environment';
import { BrowserModule } from '@angular/platform-browser';
import { NgxUiLoaderRouterModule } from 'ngx-ui-loader';
import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './shared/shared.module';
import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
import localeEn from '@angular/common/locales/en';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { RouterModule } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { WindowRef } from './window';
import { AppLocaleService, resolveInitialAngularLocale } from './shared/services/app-locale.service';
import { AuthRefreshService } from './auth/services/auth-refresh.service';
import { ReleaseNotesModule } from './features/release-notes/release-notes.module';


registerLocaleData(localeIt);
registerLocaleData(localeEn);

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(
    http,
    `${environment.i18nPrefix}/assets/i18n/`,
    '.json'
  );
};


@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    // `prefers-reduced-motion` reaches TWO engines, and the CSS reset in styles.scss reaches one.
    // Angular Material's menu, select panel, dialog, snackbar, expansion panel and sidenav are
    // `@angular/animations` triggers played through `element.animate()` -- a Web Animation, whose
    // timing comes from the call and is never overridden by an `!important` duration in a
    // stylesheet. Swapping the driver for the no-op one under the preference is the only switch that
    // reaches them, and it also sets ANIMATION_MODULE_TYPE to 'NoopAnimations', which Material's own
    // components read to drop their CSS-level ripples and transitions.
    // DECIDED ONCE, AT BOOT: the driver is chosen when this module is evaluated, so a user who flips
    // the OS setting mid-session keeps the CSS half (a live media query) and gets the JavaScript half
    // on the next load. Live switching would mean swapping the animation renderer under a running
    // app, which Angular does not support.
    BrowserAnimationsModule.withConfig({ disableAnimations: prefersReducedMotion() }),
    BrowserModule,
    NgxUiLoaderRouterModule.forRoot({showForeground: false}),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    StoreCustomModule,
    CoreModule,
    SharedModule,
    HttpClientModule,
    MaterialModule,
    MatNativeDateModule,
    AppRoutingModule,
    RouterModule.forRoot([]),
    EffectsModule.forRoot([]),
    ReleaseNotesModule,

  ],
  providers: [
    {provide: SIDENAV_CONFIG, useValue: MENU_ITEMS},
    {provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: {floatLabel: 'auto', appearance: 'outline'}},
    WindowRef,
    { provide: LOCALE_ID, useFactory: resolveInitialAngularLocale },
    { provide: DEFAULT_CURRENCY_CODE, useValue: ''},
    { provide: DateAdapter, useClass: FixedFormatDateAdapter },
    {
      provide: APP_INITIALIZER,
      useFactory: (appLocale: AppLocaleService) => () => { appLocale.init(); return true; },
      deps: [AppLocaleService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (authRefresh: AuthRefreshService) => () => authRefresh.bootstrap(),
      deps: [AuthRefreshService],
      multi: true
    },
    { provide: MatPaginatorIntl, useClass: CustomPaginatorIntl },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
